/**
 * NewItemsPriceCtrl controller
 * Crop image
 */

// controller mixins
NewItemsPriceCtrl.mixes = [
  'openPopupCtrlMixin'
]

/**
 * NewItemsPriceCtrl controller
 *
 * @class NewItemsPriceCtrl
 *
 * @ngdoc controller
 * @name mwApp/crop.controller:NewItemsPriceCtrl
 */
/* @ngInject */
export default function NewItemsPriceCtrl ($scope, $uibModalInstance, subscriptions, cs) {
  var vm = this
  vm.cs = cs
  vm.subscriptions = subscriptions

  vm.submit = function () {
    $uibModalInstance.close(vm.subscriptions)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/seasons.controller:NewItemsPriceCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
